import 'scss/solutions/liveSolution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/liveSolution.js